import { WHATSAPP_CTA_URL } from '../../../data/whatsapp';
import { openTrackedWhatsAppUrl } from '../../../lib/tracking/whatsapp';

export default function FinalCTA() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      className="py-28 relative overflow-hidden"
      style={{ background: 'var(--footer-bg)' }}
    >
      {/* Soft gradient blobs on dark */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div
          className="absolute -top-32 -left-32 w-[500px] h-[500px] rounded-full"
          style={{
            background: 'radial-gradient(circle, rgba(200,131,42,0.18) 0%, transparent 70%)',
            filter: 'blur(80px)',
          }}
        />
        <div
          className="absolute -bottom-32 -right-32 w-[400px] h-[400px] rounded-full"
          style={{
            background: 'radial-gradient(circle, rgba(200,131,42,0.12) 0%, transparent 70%)',
            filter: 'blur(80px)',
          }}
        />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 text-center">
        <span
          className="inline-block px-4 py-1.5 rounded-full text-xs font-semibold mb-6"
          style={{ background: 'rgba(200,131,42,0.15)', color: 'var(--footer-accent)', fontFamily: "'DM Sans', sans-serif", border: '1px solid rgba(200,131,42,0.25)' }}
        >
          Homenagear alguém agora
        </span>

        <h2
          className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 max-w-3xl mx-auto"
          style={{ color: '#FFFFFF', fontFamily: "'DM Sans', sans-serif", fontWeight: 800, letterSpacing: '-0.03em', lineHeight: '1.12' }}
        >
          Alguém especial merece ouvir isso{' '}
          <em className="italic" style={{ color: 'var(--gold)' }}>
            hoje
          </em>
        </h2>

        <p
          className="text-base md:text-lg max-w-xl mx-auto mb-10"
          style={{ color: 'rgba(255,255,255,0.80)', fontFamily: "'DM Sans', sans-serif", fontWeight: 300 }}
        >
          Em menos de 30 minutos, a história de quem você ama vira uma música inesquecível.
          Não espere a próxima data especial — qualquer dia é dia de emocionar.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button
            onClick={() => { void openTrackedWhatsAppUrl(WHATSAPP_CTA_URL, { newTab: false }); }}
            className="px-10 py-4 rounded-full font-semibold text-base transition-all duration-200 cursor-pointer whitespace-nowrap"
            style={{
              background: 'var(--gold)',
              color: '#FFFFFF',
              fontFamily: "'DM Sans', sans-serif",
              boxShadow: '0 4px 24px rgba(200,131,42,0.40)',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'var(--gold-hover)';
              e.currentTarget.style.boxShadow = '0 6px 32px rgba(200,131,42,0.50)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'var(--gold)';
              e.currentTarget.style.boxShadow = '0 4px 24px rgba(200,131,42,0.40)';
            }}
          >
            Criar Minha Música Agora
          </button>
          <div className="flex items-center gap-2">
            <i className="ri-mail-line text-lg" style={{ color: 'var(--gold)' }} />
            <span
              className="text-sm"
              style={{ color: 'rgba(255,255,255,0.50)', fontFamily: "'DM Sans', sans-serif" }}
            >
              Entrega por e-mail em até 30 min
            </span>
          </div>
        </div>

        {/* Social proof strip */}
        <div
          className="mt-14 pt-10 flex flex-wrap justify-center gap-8"
          style={{ borderTop: '1px solid rgba(255,255,255,0.08)' }}
        >
          {[
            { value: '+1.200', label: 'músicas entregues' },
            { value: '4.9★', label: 'avaliação média' },
            { value: '30min', label: 'entrega garantida' },
            { value: '100%', label: 'garantia de satisfação' },
          ].map((item) => (
            <div key={item.label} className="flex flex-col items-center">
              <span
                className="text-2xl font-bold"
                style={{ color: '#FFFFFF', fontFamily: "'DM Sans', sans-serif", fontWeight: 800 }}
              >
                {item.value}
              </span>
              <span
                className="text-xs mt-0.5"
                style={{ color: 'rgba(255,255,255,0.70)', fontFamily: "'DM Sans', sans-serif" }}
              >
                {item.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
